const w = '<svg xmlns="http://www.w3.org/2000/svg" data-icon-kind="lucide" viewBox="0 0 24 24" aria-hidden="true"><path d="m18 9-6-6-6 6m6-6v14m-7 4h14"/></svg>';
export {
  w
};
